module.exports = __webpack_public_path__ + "static/img/chataxera.d612f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/chataxera.png
// module id = ZMiC
// module chunks = 34